import api from '@/lib/api'

export default {
  namespaced: true,

  state: {
    show: false,
  },
  getters: {},
  mutations: {
    show: (s, b) => {
      s.show = b
    },
  },
  actions: {},
}
